$shm_echarts $mol_view
	dom_name \div
	option null
	option_themed <= option null
	animation_duration_initial 300
	animation_duration_update 300
	animation_easing \cubicInOut
	lights false
	click? null
	brush_end? null
	finished? null
	brush_cursor null
	grid_rect *
		x 0
		y 0
		width 0
		height 0
	sub null
